import { render, staticRenderFns } from "./MoreBtn.vue?vue&type=template&id=77b03796&scoped=true"
import script from "./MoreBtn.vue?vue&type=script&lang=js"
export * from "./MoreBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b03796",
  null
  
)

export default component.exports